export default __webpack_public_path__ + "static/media/refund.e92ba26b.svg";